// @flow
import * as React from 'react';
import LoadingSection from 'components/LoadingSection';
import Layout from '../layouts/Layout';

const LoadingPage = ({
  delay,
  navSection
}: {
  delay?: number,
  navSection?: 'MAIN' | 'STAFF'
}) => (
  <Layout navSection={navSection}>
    <LoadingSection delay={delay} />
  </Layout>
);

export default LoadingPage;
